import create from 'zustand';

export default create(set => ({
  establishment: null,
  setEstablishment: newEstablishment =>
    set({ establishment: newEstablishment }),
}));
